import { v4 as uuidv4 } from "uuid";
import MaleLyingFull from "../images/male_lying_full.jpg";
import MaleLyingPortrait from "../images/male_lying_portrait.jpg";
import FemaleLyingFull from "../images/female_lying_full.jpg";
import FemaleLyingPortrait from "../images/female_lying_portrait.jpg";
import PatientPortraitNewImage from "../images/patient.png";
import DoctorImage from "../images/doctor.png";
import DoctorSmileImage from "../images/doctor_smile.png";
import ClinicPresentation from "../images/presentation_clinic.jpg";
import MobilePresentation from "../images/presentation_clinic_small.jpg";
import StageBackground from "../images/menu_stage.jpg";
import BedImage from "../images/full_bed.jpg";
import StageCarousel from "../images/stage_carousel.jpg";
import MobileBed from "../images/mobile_bed.jpg";
import MobileStage from "../images/mobile_stage.jpg";

// fetchImageByName fetches background image by name
export const fetchImageByName = (name) => {
  switch (name) {
    case "maleLyingFull":
      return MaleLyingFull;
    case "femaleLyingFull":
      return FemaleLyingFull;
    case "maleLyingPortrait":
      return MaleLyingPortrait;
    case "femaleLyingPortrait":
      return FemaleLyingPortrait;
    case "patientPortraitNew":
      return PatientPortraitNewImage;
    case "doctor":
      return DoctorImage;
    case "doctor_smile":
      return DoctorSmileImage;
    case "presentation":
      return ClinicPresentation;
    case "mobilePresentation":
      return MobilePresentation;
    case "stageBackground":
      return StageBackground;
    case "bed":
      return BedImage;
    case "stageCarousel":
      return StageCarousel;
    case "mobileBed":
      return MobileBed;
    case "mobileStage":
      return MobileStage;
    default:
      return;
  }
};

export const generateFileName = async (file) => {
  let rng = uuidv4();
  let array = file.name.split(".");
  return rng + "." + array[1];
};
